// Wrapper over some loading operations to improve things a tad.
import * as THREE from "three";
import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader";
import {ModelObjectStore, ModelStore, ShaderStore, TextureStore} from "./utils";

export function loadModel(manager, model) {
    const loader = new THREE.JSONLoader();
    loader.load(model["path"], function (geometry, materials) {
        const object = null;
        ModelStore.setModel(model["name"], object, geometry, materials);
        manager.itemStart(model["path"]);
        manager.itemEnd(model["path"]);
        manager.OnItemFinished();
    });
}

// TODO - look into packing things together somehow?

// Load one of our packed shader objects.

export function loadPackedShader(manager, object) {
    console.log("Loading ", object["name"]);
}

export function loadObject(manager, object) {
    console.log("Loading ", object["name"]);
    const loader = new THREE.ObjectLoader(manager);
    loader.load(object["path"], function (obj) {
        console.log("Loaded object " + object["name"]);
        ModelObjectStore.setObject(object["name"], obj);
        manager.OnItemFinished();
    });
}

// Attempt loading a GLTF object
export function loadGLTF(manager, object) {
    console.log("Loading ", object["name"]);
    const loader = new GLTFLoader(manager);
    console.log(loader);
    // Do we want to override the material here?
    loader.load(object["path"],
        function (obj) {
            if (obj === undefined || object === null) {
                console.log('undef');
            }
            console.log(obj);
            console.log("Loaded GLTF object " + object["name"]);
            ModelObjectStore.setObject(object["name"], obj);
            manager.OnItemFinished();
        }
    );
}

// TODO: Replace these with the file loader.
export function loadShader(manager, t) {
    console.log("Loading ", t["name"]);
    fetch(t["path"])
        .then ( data => {
            return data.text();
        })
        .then(data => {
                ShaderStore.set(t["name"], data);
                manager.itemStart(t["path"]);
                manager.itemEnd(t["path"]);
                manager.OnItemFinished();
        });
}

export function loadTexture(manager, t) {
    console.log("Loading ", t["name"]);
    const loader = new THREE.ImageLoader(manager);
    loader.load(
        t["path"],
        function (image) {
            const texture = new THREE.Texture();
            texture.image = image;
            texture.needsUpdate = true;
            TextureStore.setTexture(t["name"], texture);
            manager.OnItemFinished();
        },
        function (xhr) {
            console.log(xhr.loaded / xhr.total * 100 + "% loaded");
        },
        function (xhr) {
            console.log("An error happened");
        }
    );
}

export function preload(modules, onComplete) {
    let models = [];
    let shaders = [];
    let textures = [];
    for (let module of modules) {
        const resources = module.resources();
        models = models.concat(resources['gltf']);
        shaders = shaders.concat(resources['shaders']);
        textures = textures.concat(resources['textures']);
    }
    let internalLoaded = 0;
    const totalCount = (textures.length + models.length + shaders.length);
    const manager = new THREE.LoadingManager();
    if (totalCount === 0) {
        onComplete();
    }
    manager.OnItemFinished = function () {
        console.log("On  item finished");
        internalLoaded = internalLoaded + 1;
        console.log("loaded " + internalLoaded + " of " + totalCount);
        if (internalLoaded >= totalCount) {
            onComplete();
        }
    };
    for (let model of models) {
        loadGLTF(manager, model);
    }
    for (let texture of textures) {
        loadTexture(manager, texture);
    }
    for (let shader of shaders) {
        loadShader(manager, shader);
    }
}
